import React, { Component } from "react";
import NavbarContainer from "../Navbar/NavbarContainer";
import { ReactComponent as PageNotFoundIcon } from "../../assets/placeholders/404.svg";
import { Link } from "react-router-dom";

import "./PageNotFound.scss";

class PageNotFound extends Component {
    state = {};
    render() {
        return (
            <div className="page-not-found">
                <NavbarContainer history={this.props.history} location={this.props.location} pageTitle="Page Not Found" />
                <div className="page-not-found-content">
                    <PageNotFoundIcon />
                    <p>Page Not Found</p>
                    <p>{`Sorry, it looks like we couldn't find what you are looking for`}</p>
                    <Link to="/home">
                        <span className="back-to-home">Back To Home</span>
                    </Link>
                </div>
            </div>
        );
    }
}

export default PageNotFound;
